import React from "react"
import { AnimateWrapper } from "@components/main/animate-wrapper/AnimateWrapper"
import ThinButton from "@components/common/thin-button/ThinButton"

import * as s from "./GermanyRichText.module.scss"

export const GermanyRichText = ({ data }) => {
  const { links, image, contentImage, contentImage2 } = data

  const imageSrc = image?.localFile
    ? image?.localFile?.publicURL
    : image?.sourceUrl
  const contentImageSrc = contentImage?.localFile
    ? contentImage?.localFile?.publicURL
    : contentImage?.sourceUrl
  const contentImage2Src = contentImage2?.localFile
    ? contentImage2?.localFile?.publicURL
    : contentImage2?.sourceUrl

  return (
    <AnimateWrapper>
      <div className={`${s.GermanyRichText}`}>
        <div dangerouslySetInnerHTML={{ __html: data.richText }} />

        {links && (
          <div className={s.Links}>
            {links.map((link, idx) => {
              if (!link.link) return null
              if (!link.link.title || !link.link.url) return null

              return (
                <ThinButton
                  key={idx}
                  to={link.link.url}
                  target={link.link.target}
                  external={link.link.target === "_blank"}
                  backgroundColor="#ffc72c"
                  textColor="#0c1a31"
                >
                  {link.link.title}
                </ThinButton>
              )
            })}
          </div>
        )}

        <img
          className={s.GermanyRichText__contentImage}
          src={contentImageSrc}
        />
        <img
          className={s.GermanyRichText__contentImage2}
          src={contentImage2Src}
        />
        <img className={s.GermanyRichText__image} src={imageSrc} />
      </div>
    </AnimateWrapper>
  )
}
